import { useEffect, useState } from 'react';
import './AutocompleteList.css';

type AutocompleteListProps = {
	items: object[];
	template: string[];
	onComplete(item: any): unknown; // generics?
	display?: boolean;
	className?: string;
};
export const AutocompleteList = ({
	items,
	template,
	onComplete,
	display = true,
	className,
}: AutocompleteListProps): JSX.Element => {
	const [focusedIndex, setFocusedIndex] = useState(-1);

	useEffect(() => {
		function keyDownListener(e: KeyboardEvent): void {
			switch (e.key) {
				case 'Enter':
					if (!!items[focusedIndex]) onComplete(items[focusedIndex]);
					break;
				case 'ArrowUp':
					setFocusedIndex((focusedIndex > 0 ? focusedIndex : items.length) - 1);
					break;
				case 'ArrowDown':
					setFocusedIndex((focusedIndex + 1) % items.length);
					break;
			}
		}

		window.addEventListener('keydown', keyDownListener);
		return () => window.removeEventListener('keydown', keyDownListener);
	});

	if (!display) return <></>;

	return (
		<ul className={`dropdown-list ${className}`}>
			{template.map((item, i) => (
				<li
					className={`dropdown-item ${focusedIndex === i ? 'focused' : ''}`}
					key={`${item.toString()}-${i}`}
					onMouseDown={(e) => {
						e.preventDefault();
						onComplete(items[i]);
					}}
				>
					{item}
				</li>
			))}
		</ul>
	);
};
